import { MILITAO_URL } from '@/config'
import type { TrialSource } from './trialSource'

export interface TrialSignUpDetails {
  name: string
  firstName?: string
  lastName?: string
  role?: string
  trialSource?: TrialSource
}

export const isOnboarding = (searchParams: URLSearchParams) => {
  return !!searchParams.get('priceId')
}

export const getCreateAccountPath = (searchParams: URLSearchParams) => {
  const path = '/create-account'
  if (!searchParams) return path
  return `${path}?${searchParams.toString()}`
}

export const getWelcomeUrl = () => {
  return `${MILITAO_URL}/welcome`
}

export const getCreateAccountUrl = (searchParams: URLSearchParams) => {
  return `${MILITAO_URL}${getCreateAccountPath(searchParams)}`
}

export const getTrialWelcomeUrl = () => `${MILITAO_URL}/trial/welcome`

// Form state does not survive the Stripe round trip, so the cancel return carries it in the query.
export const getTrialAddCardUrl = ({
  name,
  role,
  trialSource,
}: TrialSignUpDetails) => {
  const query = new URLSearchParams({ name })
  if (role) query.set('role', role)
  if (trialSource) query.set('trial_source', JSON.stringify(trialSource))
  return `${MILITAO_URL}/trial/add-card?${query.toString()}`
}

export const toAddCardSearch = ({
  name,
  role,
  trialSource,
}: TrialSignUpDetails) => ({ name, role, trial_source: trialSource })
